import { BsFillPersonVcardFill } from "react-icons/bs";
import { HiMiniUserGroup } from "react-icons/hi2";
import { BiSolidMessageRounded } from "react-icons/bi";
import { IoMdVideocam } from "react-icons/io";
import { TfiAnnouncement } from "react-icons/tfi";

export const listLeftDatas = [
  {
    linkClass: "tyn-appbar-link position-relative",
    linkTo: "/",
    icon: <BiSolidMessageRounded />,
    indicator: (
      <div className="badge bg-primary position-absolute rounded-pill top-0 end-0 mt-n1 me-n1">
        *
      </div>
    ),
    span: "Messages",
  },
  {
    linkClass: "tyn-appbar-link",
    linkTo: "/annuaire",
    icon: <BsFillPersonVcardFill />,
    span: "Annuaire",
  },
  {
    linkClass: "tyn-appbar-link",
    linkTo: "/groupes",
    icon: <HiMiniUserGroup />,
    span: "Groupes",
  },
  {
    linkClass: "tyn-appbar-link",
    linkTo: "/annonces",
    icon: <TfiAnnouncement />,
    indicator: (
      <div className="badge bg-primary position-absolute rounded-pill top-0 end-0 mt-n1 me-n1">
        *
      </div>
    ),
    span: "Annonces",
  },
  {
    linkClass: "tyn-appbar-link",
    linkTo: "/reunion",
    icon: <IoMdVideocam />,
    span: "Réunion",
  },
  // {
  //   linkClass: "tyn-appbar-link",
  //   linkTo: "/gestion-des-utilisateurs/utilisateurs",
  //   icon: <FaUserEdit />,
  //   span: "Comptes utilisateurs",
  // },
];
